package dev.lingvo.shared

import kotlinx.serialization.Serializable

/** Export callers choose raw inputs or composed store images explicitly. */
@Serializable
enum class ShotExportKind { CAPTURES, RENDERS }

/** Layout is independent of image kind so the same manifest serves both import tools. */
@Serializable
enum class ShotExportLayout { FASTLANE, PLAIN }

/** Manifest entries retain provenance while preserving the six keys read by the CLI. */
@Serializable
data class ShotExportFile(
    val path: String, val slot: String, val device: String, val locale: String, val storeLocale: String,
    val bytes: Long, val sha256: String, val approved: Boolean, val captionHash: String? = null,
)

/** A versioned manifest makes a streamed ZIP independently inspectable. */
@Serializable
data class ShotExportManifest(
    val version: Int = 1, val platform: StorePlatform, val kind: ShotExportKind, val layout: ShotExportLayout,
    val generatedAt: String, val approvedSet: Boolean, val files: List<ShotExportFile>,
    val ignored: List<String> = emptyList(),
)
